import { render, staticRenderFns } from "./MessagesMain.vue?vue&type=template&id=ac2be708&scoped=true&"
import script from "./MessagesMain.vue?vue&type=script&lang=js&"
export * from "./MessagesMain.vue?vue&type=script&lang=js&"
import style0 from "./MessagesMain.vue?vue&type=style&index=0&id=ac2be708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2be708",
  null
  
)

export default component.exports